import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=4d3d32de&scoped=true"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=4d3d32de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d32de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3d32de')) {
      api.createRecord('4d3d32de', component.options)
    } else {
      api.reload('4d3d32de', component.options)
    }
    module.hot.accept("./SettingsGeneral.vue?vue&type=template&id=4d3d32de&scoped=true", function () {
      api.rerender('4d3d32de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsGeneral.vue"
export default component.exports